import { render } from "./AuthBase.vue?vue&type=template&id=515795e4"
import script from "./AuthBase.vue?vue&type=script&lang=js"
export * from "./AuthBase.vue?vue&type=script&lang=js"

import "./AuthBase.vue?vue&type=style&index=0&id=515795e4&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__